module.exports = __webpack_public_path__ + "img/pos.83603bf3.svg";